import dsfrIcons from "apps/front-office/public/utility/icons/utility-icons.json";
import dsfrPictograms from "apps/front-office/public/utility/pictograms/utility-pictograms.json";
import AccordionIcon from "components/adminComponents/contentForms/icons/AccordionIcon";
import ExpansionPanelIcon from "components/adminComponents/contentForms/icons/ExpansionPanelIcon";
import InfoBlockIcon from "components/adminComponents/contentForms/icons/InfoBlockIcon";
import TimelineIcon from "components/adminComponents/contentForms/icons/TimelineIcon";
import { styleKeys } from "components/templatesComponents/card/cardStyles";
import lodash from "lodash";
import { accentColorDsfrTypes } from "utils/colorDsfrTypes";
import types from "utils/elementsTypes";
import geolocSourceType from "utils/geolocSourceType";
import videosOrigins from "utils/videosOrigins";
import { v4 as uuidv4 } from "uuid";

export const contents = [
  {
    type: types.ACCORDION,
    label: "Accordéon",
    IconComponent: AccordionIcon,
    value: "",
    children: [
      {
        key: "panels",
        type: types.ACCORDION_PANEL,
      },
    ],
  },
  {
    label: "Panneau dépliant",
    type: types.ACCORDION_PANEL,
    value: "",
    editionModal: true,
    children: [
      {
        label: "Titre du paneau",
        key: "summary",
        type: types.INPUT,
        value: "Mon titre",
      },
      {
        key: "details",
        type: types.EXPANSION_PANEL_DETAILS,
        value: "",
      },
    ],
  },
  {
    type: types.ATTACHMENTS,
    label: "Liste de pièces jointes",
    iconDSFR: "list-unordered",
  },
  {
    label: "Pièce jointe",
    type: types.ATTACHMENT,
    iconDSFR: "attachment-line",
    editionModal: true,
    children: [
      {
        label: "Choisir un document",
        key: "file",
        type: types.FILE,
      },
      {
        label: "Texte du lien",
        key: "linkText",
        type: types.INPUT,
        value: "Télécharger le fichier",
      },
      {
        label: "Description",
        key: "description",
        type: types.INPUT,
        value: "Entrez la description de la pièce jointe",
      },
      {
        label: "Afficher la date de publication",
        key: "publishDate",
        type: types.CHECKBOX,
        value: "false",
      },
    ],
  },
  {
    label: "Pièce jointe",
    type: types.ATTACHMENT_LINK,
    editionModal: true,
    children: [
      {
        label: "Choisir un document",
        key: "file",
        type: types.FILE,
      },
      {
        label: "Texte du lien",
        key: "linkText",
        type: types.INPUT,
        value: "Télécharger le fichier",
      },
    ],
  },
  {
    label: "Bouton",
    type: types.BUTTON,
    iconDSFR: "cursor-fill",
    editionModal: true,
    children: [
      {
        key: "text",
        type: types.INPUT,
        value: "Texte",
      },
      {
        label: "Lien du bouton",
        key: "link",
        type: types.LINK,
      },
      {
        label: "Type de bouton",
        key: "kind",
        width: "41%",
        type: types.SELECT,
        options: [
          { label: "Primaire", value: "primary" },
          { label: "Secondaire", value: "secondary" },
          { label: "Tertiaire", value: "tertiary" },
          { label: "Tertiaire sans bordure", value: "tertiary-no-outline" },
        ],
        value: "primary",
      },
      {
        label: "Taille du bouton",
        key: "size",
        width: "27%",
        type: types.SELECT,
        options: [
          { label: "Petit", value: "sm" },
          { label: "Moyen", value: "md" },
          { label: "Grand", value: "lg" },
        ],
        value: "md",
      },
      {
        label: "Placement de l'icône",
        key: "iconPosition",
        width: "27%",
        type: types.SELECT,
        options: [
          { label: "Gauche", value: "left" },
          { label: "Droite", value: "right" },
        ],
        value: "right",
      },
      {
        label: "Icone",
        key: "icon",
        type: types.ICON,
        value: "",
      },
      {
        label: "Prendre toute la largeur",
        key: "fullWidth",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        label: "Couleur de la thématique",
        key: "secondaryColor",
        type: types.CHECKBOX,
        value: "false",
      },
    ],
  },
  {
    label: "Cards",
    type: types.CARDS_LIST,
    value: "",
    children: [
      {
        label: "Style desktop",
        key: "desktopStyleKey",
        type: types.SELECT,
        options: Object.keys(styleKeys).map((k) => ({ label: k, value: k })),
        value: "",
      },
      {
        label: "Style mobile",
        type: types.SELECT,
        options: Object.keys(styleKeys).map((k) => ({ label: k, value: k })),
        key: "mobileStyleKey",
        value: "",
      },
    ],
  },
  {
    label: "Liste cards actualités",
    type: types.CARDS_LIST_NEWS,
    value: "",
    children: [],
  },
  {
    label: "Liste cards anciennes actualités",
    type: types.OLD_CARDS_LIST_NEWS,
    value: "",
    children: [],
  },
  {
    label: "Liste de cartes",
    type: types.DSFR_CARDS_LIST,
    iconDSFR: "layout-grid-line",
  },
  {
    label: "Liste de cartes",
    type: types.DSFR_CARDS_SPECIFIC_LIST,
    iconDSFR: "layout-grid-line",
  },
  {
    label: "Liste de tuiles",
    type: types.TILE_CARDS_LIST,
    iconDSFR: "layout-grid-line",
  },
  {
    label: "Liste de tuiles",
    type: types.TILE_CARDS_SPECIFIC_LIST,
    iconDSFR: "layout-grid-line",
  },
  {
    label: "Card",
    type: types.CARD,
    editionModal: true,
    value: "",
    children: [
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
      {
        key: "page",
        type: types.PAGE,
        value: "",
      },
      {
        key: "title",
        label: "Titre",
        type: types.INPUT,
        value: "",
      },
      {
        key: "description",
        label: "Description courte",
        type: types.SHORT_TEXT,
        value: "",
      },
      {
        label: "Lien",
        type: types.LINK,
        key: "link",
        children: [
          {
            label: "Url",
            key: "url",
            type: types.URL,
            value: "",
          },
          {
            label: "Page",
            key: "page",
            type: types.PAGE,
            value: "",
          },
          {
            key: "title",
            label: "Titre du lien",
            type: types.INPUT,
            value: "",
          },
          {
            label: "Nouvel onglet",
            key: "external",
            type: types.CHECKBOX,
            value: "false",
          },
        ],
      },
    ],
  },
  {
    label: "Actualité à la une",
    type: types.CARD_NEWS,
    editionModal: true,
    value: "",
    children: [
      {
        key: "page",
        type: types.PAGE,
        value: "",
      },
    ],
  },
  {
    label: "Actualité",
    type: types.OLD_CARD_NEWS,
    editionModal: true,
    value: "",
    children: [
      {
        key: "title",
        label: "Titre de la card",
        type: types.INPUT,
        value: "",
      },
      {
        key: "description",
        label: "Description de la card",
        type: types.INPUT,
        value: "",
      },
      {
        key: "page",
        type: types.PAGE,
        value: "",
      },
    ],
  },
  {
    label: "Card",
    type: types.DSFR_CARD,
    editionModal: true,
    value: "",
    children: [
      {
        key: "page",
        type: types.PAGE,
        value: "",
      },
      {
        key: "site",
        label: "Filtrer par site / Label de site",
        type: types.SELECT,
        options: [
          { label: "Ants", value: "ANTS" },
          { label: "Immatriculation", value: "IMMAT" },
          { label: "Passeport / CNI", value: "PASSEPORT_CNI" },
          { label: "Permis", value: "PERMIS" },
          { label: "Auto-École ET CSSR", value: "AUTO_ECOLE" },
          { label: "Professionnels de l'automobile", value: "PHA" },
          { label: "Mairie", value: "MAIRIE" },
        ],
      },
      {
        key: "title",
        label: "Titre",
        type: types.INPUT,
        value: "",
      },
      {
        key: "description",
        label: "Description courte",
        type: types.SHORT_TEXT,
        value: "",
      },
      {
        label: "Lien",
        type: types.LINK,
        key: "link",
      },
      {
        label: "Taille du titre",
        key: "titleSize",
        type: types.SELECT,
        options: [
          { label: "Petit", value: "sm" },
          { label: "Normal", value: "md" },
        ],
        value: "md",
      },
    ],
  },
  {
    label: "Tuile",
    type: types.TILE_CARD,
    editionModal: true,
    value: "",
    children: [
      {
        key: "title",
        label: "Titre de la card",
        type: types.INPUT,
        value: "",
      },
      {
        key: "description",
        label: "Description de la card",
        type: types.INPUT,
        value: "",
      },
      {
        key: "site",
        label: "Filtrer par site",
        type: types.SELECT,
        options: [
          { label: "Ants", value: "ANTS" },
          { label: "Immatriculation", value: "IMMAT" },
          { label: "Passeport / CNI", value: "PASSEPORT_CNI" },
          { label: "Permis", value: "PERMIS" },
          { label: "Auto-École ET CSSR", value: "AUTO_ECOLE" },
          { label: "Professionnels de l'automobile", value: "PHA" },
          { label: "Mairie", value: "MAIRIE" },
        ],
      },
      {
        key: "page",
        type: types.PAGE,
        value: "",
      },
      {
        label: "Lien",
        key: "link",
        type: types.LINK,
      },
      {
        label: "Pictogramme",
        key: "pictogram",
        type: types.PICTOGRAM,
        value: "",
      },
      {
        label: "Taille du titre",
        key: "titleSize",
        type: types.SELECT,
        options: [
          { label: "Petit (sm)", value: "sm" },
          { label: "Normal (md)", value: "md" },
        ],
        value: "md",
      },
      {
        label: "Tuile horizontale",
        key: "isHorizontal",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        label: "Prendre toute la largeur",
        key: "fullWidth",
        type: types.CHECKBOX,
        value: "false",
      },
    ],
  },
  {
    type: types.CHECKBOX,
  },
  {
    label: "Afficher le logo sur le site",
    type: types.ALONE_CHECKBOX,
  },
  {
    label: "",
    type: types.ALONE_CHECKBOX_NO_LABEL,
  },
  {
    label: "Activer la démarche alternative mobile",
    type: types.ALONE_CHECKBOX_PROCESS_DSFR,
  },
  {
    label: "Afficher le sommaire",
    type: types.ALONE_CHECKBOX_SUMMARY,
  },
  {
    type: types.CONTACT_FORM_PROFILE_LIST,
    value: "",
    children: [
      {
        key: "ContactFormProfiles",
        type: types.CONTACT_FORM_PROFILE,
        value: "",
      },
    ],
  },
  {
    type: types.CONTACT_FORM_PROFILE,
    value: "",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Nouveau profil",
      },
    ],
  },
  {
    type: types.CALLBACK_REASON_LIST,
    value: "",
    children: [
      {
        key: "CallbackReasons",
        type: types.CALLBACK_REASON,
        value: "",
      },
    ],
  },
  {
    type: types.CALLBACK_REASON,
    value: "",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Nouveau motif",
      },
      {
        key: "value",
        type: types.INPUT,
        value: "",
      },
    ],
  },
  {
    type: types.CONTACT_FORM_SUBJECT_LIST,
    value: "",
    children: [
      {
        key: "ContactFormSubjects",
        type: types.CONTACT_FORM_SUBJECT,
        value: "",
      },
    ],
  },
  {
    type: types.CONTACT_FORM_SUBJECT,
    value: "",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Nouvel objet",
      },
      {
        key: "recipient",
        type: types.INPUT,
        value: "",
      },
      {
        key: "autoReply",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        key: "canContact",
        type: types.CHECKBOX,
        value: "true",
      },
      {
        key: "replyMessage",
        type: types.TEXT,
        value: "",
      },
    ],
  },
  {
    type: types.CONTENTS_GROUPS_LIST,
    value: "",
    children: [
      {
        type: types.CONTENTS_GROUP,
        key: "groups",
      },
    ],
  },
  {
    type: types.CONTENTS_GROUP,
    value: "",
    children: [
      {
        type: types.INPUT,
        key: "name",
        value: "",
      },
      {
        key: "contents",
      },
    ],
  },
  {
    label: "Choisir un fichier",
    type: types.FILE,
  },
  {
    label: "Panneau dépliant",
    type: types.EXPANSION_PANEL,
    IconComponent: ExpansionPanelIcon,
    editionModal: true,
    children: [
      {
        label: "Titre du paneau",
        key: "summary",
        type: types.INPUT,
        value: "Mon titre",
      },
      {
        key: "details",
        type: types.EXPANSION_PANEL_DETAILS,
      },
    ],
  },
  {
    type: types.EXPANSION_PANEL_DETAILS,
  },
  {
    label: "Texte dépliant",
    type: types.EXPANSION_TEXT,
    iconDSFR: "arrow-down-s-line",
    editionModal: true,
    children: [
      {
        label: "Libellé replié",
        key: "reducedLabel",
        type: types.INPUT,
        value: "Voir plus",
      },
      {
        label: "Libellé déplié",
        key: "expandedLabel",
        type: types.INPUT,
        value: "Voir moins",
      },
      {
        label: "Déplié par défaut",
        key: "defaultExpanded",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        key: "text",
        type: types.TEXT,
      },
    ],
  },
  {
    type: types.DYNAMIC,
  },
  {
    label: "Type d'établissement",
    type: types.GEOLOC_SOURCETYPE,
    options: Object.values(geolocSourceType).map((geolocType) => ({
      label: geolocType,
      value: geolocType,
    })),
    value: Object.values(geolocSourceType)[0],
  },
  {
    type: types.GLOSSARY,
  },
  {
    label: "Définition",
    type: types.GLOSSARY_ITEM,
    // editionModal: true,
    children: [
      {
        key: "word",
        label: "Mot / Acronyme",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Description",
        key: "description",
        type: types.SHORT_TEXT,
        value: "",
      },
    ],
  },
  {
    label: "Grille",
    type: types.GRID,
    iconDSFR: "layout-grid-line",
    editionModal: true,
    children: [
      {
        key: "autoAdjust",
        label: "Ajustement automatique",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        key: "size",
        label: "Nombre de colonnes",
        type: types.SELECT,
        options: [
          { label: "2 colonnes", value: "6" },
          { label: "3 colonnes", value: "4" },
          { label: "4 colonnes", value: "3" },
          { label: "6 colonnes", value: "2" },
        ],
        value: "6",
      },
      {
        key: "sizeXs",
        label: "Nombre de colonnes en mobile",
        type: types.SELECT,
        options: [
          { label: "1 colonne", value: "12" },
          { label: "2 colonnes", value: "6" },
          { label: "3 colonnes", value: "4" },
          { label: "4 colonnes", value: "3" },
        ],
        value: "12",
      },
    ],
  },
  {
    type: types.STORE_BUTTONS,
    editionModal: true,
    children: [
      {
        key: "androidLink",
        label: "Lien vers l'app Android",
        type: types.INPUT,
        value: "",
      },
      {
        key: "iosLink",
        label: "Lien vers l'app iOS",
        type: types.INPUT,
        value: "",
      },
    ],
  },
  {
    type: types.TEXT_ICON,
    editionModal: true,
    children: [
      {
        key: "text",
        type: types.INPUT,
        value: "",
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
    ],
  },
  {
    label: "Alerte",
    type: types.ALERT,
    editionModal: true,
    iconDSFR: "feedback-fill",
    children: [
      {
        key: "title",
        label: "Titre",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        key: "type",
        label: "Type d'alerte",
        type: types.SELECT,
        options: [
          { label: "Information", value: "info" },
          { label: "Erreur", value: "error" },
          { label: "Attention", value: "warning" },
          { label: "Succès", value: "success" },
        ],
        value: "info",
      },
    ],
  },
  {
    label: "Icône",
    type: types.ICON,
    value: "",
    children: [
      {
        label: "Nom",
        key: "icon",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Type",
        key: "type",
        type: types.SELECT,
        options: [
          { label: "Solid", value: "fas" },
          { label: "Regular", value: "far" },
          { label: "Light", value: "fal" },
          { label: "Duotone", value: "fad" },
          { label: "Brands", value: "fab" },
        ],
        value: "fal",
      },
      {
        key: "iconDSFR",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Groupe",
        key: "groupDSFR",
        type: types.SELECT,
        options: Object.keys(dsfrIcons).map((group) => {
          return { label: group, value: group };
        }),
        value: "",
      },
    ],
  },
  {
    label: "Icône (DSFR)",
    type: types.ICON_DSFR,
    editionModal: true,
    value: "",
    children: [
      {
        key: "iconDSFR",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Groupe",
        key: "groupDSFR",
        type: types.SELECT,
        options: Object.keys(dsfrIcons).map((group) => {
          return { label: group, value: group };
        }),
        value: "",
      },
    ],
  },
  {
    label: "Pictogramme",
    type: types.PICTOGRAM,
    value: "",
    children: [
      {
        key: "pictogram",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Groupe",
        key: "folder",
        type: types.SELECT,
        options: Object.keys(dsfrPictograms).map((folder) => {
          return { label: folder, value: folder };
        }),
        value: "",
      },
    ],
  },
  {
    label: "Lien",
    type: types.ICON_LINK,
    iconDSFR: "links-line",
    editionModal: true,
    children: [
      {
        key: "text",
        type: types.INPUT,
        value: "Texte",
      },
      {
        label: "Lien",
        key: "link",
        type: types.LINK,
      },
      {
        label: "Placement de l'icône",
        key: "iconPosition",
        width: "45%",
        type: types.SELECT,
        options: [
          { label: "Gauche", value: "left" },
          { label: "Droite", value: "right" },
        ],
        value: "right",
      },
      {
        label: "Taille du lien",
        key: "size",
        width: "45%",
        type: types.SELECT,
        options: [
          { label: "Petit", value: "sm" },
          { label: "Moyen", value: "md" },
          { label: "Grand", value: "lg" },
        ],
        value: "md",
      },
      {
        key: "icon",
        type: types.ICON,
      },
    ],
  },
  {
    label: "Choisir une image",
    type: types.FILE_IMAGE,
  },
  {
    label: "Image",
    iconDSFR: "image-line",
    type: types.IMAGE,
    children: [
      {
        key: "file",
        type: types.FILE_IMAGE,
        value: "",
      },
      {
        label: "Texte alternatif",
        key: "alt",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Titre (visible au survol)",
        key: "title",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Position",
        key: "position",
        type: types.SELECT,
        options: [
          { label: "Haute", value: "top" },
          { label: "Centrée", value: "center" },
          { label: "Basse", value: "bottom" },
        ],
        value: "center",
      },
    ],
  },
  {
    label: "Image",
    type: types.IMAGE_BLOCK,
    iconDSFR: "image-fill",
    editionModal: true,
    value: "",
    children: [
      {
        key: "image",
        type: types.IMAGE,
      },
      {
        label: "Largeur de l'image (en %)",
        key: "width",
        type: types.SLIDER,
      },
      {
        label: "Largeur de l'image (en %) sur mobile",
        key: "mobileWidth",
        type: types.SLIDER,
      },
      {
        key: "justifyContent",
        label: "Alignement",
        type: types.SELECT,
        options: [
          { label: "À gauche", value: "flex-start" },
          { label: "Centré", value: "center" },
          { label: "À droite", value: "flex-end" },
        ],
        value: "flex-start",
      },
      {
        key: "legend",
        label: "Légende de l'image",
        type: types.EDITABLE_INPUT,
        value: "",
      },
    ],
  },
  {
    label: "Mise en avant",
    type: types.INFO_BLOCK,
    IconComponent: InfoBlockIcon,
    editionModal: true,
    children: [
      {
        key: "title",
        label: "Titre mise en avant",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
      {
        key: "text",
        label: "Texte",
        type: types.TEXT,
        value: "",
      },
      {
        key: "link",
        label: "Lien du bouton",
        type: types.LINK,
        children: [
          {
            key: "title",
            label: "Texte du bouton",
            type: types.INPUT,
            value: "Bouton",
          },
        ],
      },
      {
        label: "Couleur d'accentuation",
        key: "accentColor",
        type: types.SELECT,
        options: accentColorDsfrTypes.map((color) => {
          return { label: color, value: color };
        }),
        value: "",
      },
    ],
  },
  {
    type: types.INFO_BLOCK_LIST,
  },
  {
    label: "Texte",
    type: types.INPUT,
    value: "",
  },
  {
    type: types.LINKS_LIST,
    label: "Liste de liens",
    iconDSFR: "list-unordered",
  },
  {
    label: "Lien",
    type: types.LINK,
    children: [
      {
        label: "Url",
        key: "url",
        type: types.URL,
        value: "",
      },
      {
        label: "Page",
        key: "page",
        type: types.PAGE,
        value: "",
      },
      {
        key: "title",
        label: "Titre du lien",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Nouvel onglet",
        key: "external",
        type: types.CHECKBOX,
        value: "false",
      },
    ],
  },
  {
    label: "Lien mailto",
    type: types.MAILTO,
    iconDSFR: "mail-line",
    editionModal: true,
    children: [
      {
        label: "Texte",
        key: "text",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Email de destination",
        key: "recipient",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Objet",
        key: "subject",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Corps",
        key: "body",
        type: types.INPUT,
        value: "",
      },
    ],
  },
  {
    label: "Groupe de liens",
    editionModal: true,
    type: types.MENU_GROUP,
    iconDSFR: "link",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "",
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
    ],
  },
  {
    label: "Lien",
    editionModal: true,
    type: types.MENU_ITEM,
    iconDSFR: "link",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "",
      },
      {
        key: "link",
        type: types.LINK,
        value: "",
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
    ],
  },
  {
    label: "Résumé de page",
    type: types.PAGE,
  },

  {
    type: types.RESULT_LIST,
    iconDSFR: "profil-line",
    label: "Liste résultats",
  },
  {
    label: "Résultat",
    type: types.RESULT,
    editionModal: true,
    children: [
      {
        label: "Pictogramme",
        key: "pictogram",
        type: types.PICTOGRAM,
        value: "",
      },
      {
        label: "Icône",
        key: "icon",
        type: types.ICON,
        children: [
          {
            key: "icon",
            type: types.INPUT,
            value: "chart-bar",
          },
        ],
      },
      {
        label: "Résultat",
        key: "number",
        type: types.NUMERIC,
        value: "12345",
      },
      {
        label: "Description du résultat",
        key: "text",
        type: types.INPUT,
        value: "Description du résultat",
      },
    ],
  },
  {
    type: types.QUOTE,
    label: "Citation",
    iconDSFR: "message-2-line",
    editionModal: true,
    children: [
      {
        label: "Type",
        key: "quoteType",
        type: types.SELECT,
        options: [
          { label: "Citation", value: "basic" },
          { label: "Citation de tweet", value: "tweet" },
        ],
        value: "basic",
      },
      {
        label: "Citation",
        key: "quote",
        type: types.TEXT,
        value: "",
      },
      {
        key: "author",
        label: "Auteur",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        key: "image",
        type: types.FILE_IMAGE,
        value: "",
      },
      {
        label: "Lien",
        key: "link",
        type: types.LINK,
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
    ],
  },
  {
    type: types.SELECT,
  },
  {
    type: types.SITE_SETTINGS,
    value: "",
    children: [
      {
        key: "urlsMapping",
        type: types.URLS_MAPPING,
        value: "",
      },
      {
        label: "Affichage du bloc",
        key: "display",
        type: types.RADIO_GROUP,
        value: "ALL",
        options: [
          { label: "Complet", value: "ALL" },
          { label: "Partage seul", value: "SHARE" },
          { label: "Aide seule", value: "HELP" },
        ],
      },
      {
        key: "selectedTemplates",
        label: "Gabarits",
        type: types.SELECT_MULTIPLE,
        value: "",
      },
      {
        key: "faqUrl",
        label: "Url de la FAQ (FR)",
        type: types.LINK,
        value: "",
      },
      {
        key: "franceServicesUrl",
        label: "Url France Services (FR)",
        type: types.LINK,
        value: "",
      },
      {
        key: "faqUrlEN",
        label: "Url de la FAQ (EN)",
        type: types.LINK,
        value: "",
      },
      {
        key: "franceServicesUrlEN",
        label: "Url France Services (EN)",
        type: types.LINK,
        value: "",
      },
      {
        key: "socialNetworks",
        type: types.SOCIAL_NETWORK,
        value: "",
      },
    ],
  },
  {
    type: types.MOURNING_SETTINGS,
    key: "mourningSettings",
    value: "",
    children: [
      {
        key: "isMourning",
        label: "Permanente",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        key: "mourningStartDate",
        label: "Date de début",
        type: types.DATE,
        value: "",
      },
      {
        key: "mourningEndDate",
        label: "Date de fin",
        type: types.DATE,
        value: "",
      },
    ],
  },
  {
    type: types.SITE_NAME,
    key: "siteName",
    value: "",
  },
  {
    label: "Plage de valeurs",
    type: types.SLIDER,
    value: "100",
    min: "0",
    max: "100",
    step: "10",
  },
  {
    label: "",
    type: types.SLIDER_INLINE,
    value: "50",
    min: "0",
    max: "100",
    step: "1",
  },
  {
    type: types.URLS_MAPPING,
    value: "",
    children: [
      {
        key: "source",
        label: "Ancienne URL",
        type: types.INPUT,
        value: "/",
      },
      {
        key: "site",
        label: "Site",
        type: types.SELECT,
        value: "",
        options: [
          { label: "Ants", value: "ANTS" },
          { label: "Immatriculation", value: "IMMAT" },
          { label: "Passeport / CNI", value: "PASSEPORT_CNI" },
          { label: "Permis", value: "PERMIS" },
          { label: "Auto-École ET CSSR", value: "AUTO_ECOLE" },
          { label: "PHA", value: "PHA" },
          { label: "Mairie", value: "MAIRIE" },
        ],
      },
      {
        key: "destination",
        label: "Nouvelle URL",
        type: types.INPUT,
        value: "/",
      },
    ],
  },
  {
    type: types.SOCIAL_NETWORK,
    value: "",
    children: [
      {
        key: "url",
        type: types.URL,
        value: "",
      },
      {
        key: "network",
        label: "Titre",
        type: types.INPUT,
        value: "",
      },
      {
        key: "icon",
        type: types.ICON,
        value: "",
      },
      {
        key: "appId",
        type: types.INPUT,
        value: "",
      },
    ],
  },
  {
    label: "Étape",
    type: types.STEP,
    children: [
      {
        key: "title",
        type: types.TEXT,
        value: "nouveau titre",
      },
      {
        key: "content",
        type: types.TEXT,
        value: "nouveau contenu",
      },
    ],
  },
  {
    label: "Étape",
    type: types.STEP_V2,
    children: [
      {
        key: "title",
        type: types.TEXT,
        value: "nouveau titre",
      },
      {
        key: "content",
        type: types.STEP_V2_CONTENT,
        value: "",
      },
    ],
  },
  {
    type: types.STEP_V2_CONTENT,
  },
  {
    label: "Sous-page prédéfinie",
    type: types.SUBPAGE,
    iconDSFR: "file-text-line",
    editionModal: true,
  },
  {
    label: "Liste de sous pages",
    type: types.SUBPAGES_LIST,
    // editionModal: true,
    value: "",
    children: [
      {
        key: "pages",
        type: types.SUBPAGE,
      },
    ],
  },
  {
    label: "Sous-page administrable",
    type: types.DSFR_SUBPAGE,
    iconDSFR: "article-line",
    editionModal: true,
    children: [
      {
        key: "template",
        type: types.SELECT,
        value: "",
        label: "Gabarit de la sous-page",
        options: [
          { label: "Actualités", value: "ALLNEWS" },
          { label: "Aide et Contact", value: "HELP" },
          { label: "Démarches en ligne", value: "PROCESSES" },
          { label: "Services", value: "PAGE_LINKS" },
          { label: "Tout savoir", value: "KNOW_EVERYTHING" },
          { label: "Template par défaut", value: "NO_TEMPLATE" },
        ],
      },
      {
        key: "title",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        key: "description",
        label: "Description",
        type: types.SHORT_TEXT,
        value: "",
      },
      {
        key: "linkTitle",
        label: "Titre du lien de la sous-page",
        type: types.INPUT,
        value: "",
      },
      {
        key: "link",
        type: types.LINK,
      },
      {
        key: "image",
        type: types.IMAGE,
      },
      {
        key: "specificCardsList",
        type: types.DSFR_CARDS_SPECIFIC_LIST,
      },
      {
        key: "cardsList",
        type: types.DSFR_CARDS_LIST,
      },
      {
        key: "specificTilesList",
        type: types.TILE_CARDS_SPECIFIC_LIST,
      },
      {
        key: "linksList",
        type: types.LINKS_LIST,
      },
      {
        key: "dynamicPart",
        type: types.DYNAMIC,
      },
    ],
  },
  {
    label: "Liste de sous pages",
    type: types.DSFR_SUBPAGES_LIST,
    value: "",
    children: [
      {
        key: "pages",
        type: types.DSFR_SUBPAGE,
      },
    ],
  },
  {
    type: types.MULTI_SUBPAGES_LIST,
  },
  {
    label: "Zone de texte",
    type: types.TEXT,
    iconDSFR: "h-1",
    value: "",
  },
  {
    label: "Mise en exergue",
    key: "highlighted",
    iconDSFR: "highlight",
    type: types.HIGHLIGHTED_TEXT,
    value: "",
  },
  {
    label: "Historique",
    type: types.TIMELINE,
    IconComponent: TimelineIcon,
    children: [
      {
        label: "Étape",
        type: types.STEP_V2,
        key: "steps",
      },
    ],
  },
  {
    label: "Etape",
    type: types.STEPPER_STEP,
    editionModal: true,
    children: [
      {
        label: "Titre",
        key: "title",
        type: types.INPUT,
        value: "Mon titre",
      },
      {
        label: "Informations complémentaires",
        key: "tooltip",
        type: types.INPUT,
        value: "",
      },
      {
        label: "Icône (associée aux informations complémentaires)",
        key: "icon",
        type: types.ICON,
        value: "",
        children: [
          {
            key: "icon",
            value: "info",
          },
          {
            key: "type",
            value: "fas",
          },
        ],
      },
      {
        key: "detail",
        type: types.STEPPER_DETAIL,
      },
    ],
  },
  {
    label: "Etape",
    type: types.STEPPER_STEP_DSFR,
    editionModal: true,
    children: [
      {
        label: "Titre",
        key: "title",
        type: types.INPUT,
        value: "Mon titre",
      },
      {
        key: "detail",
        type: types.STEPPER_DETAIL_DSFR,
      },
    ],
  },
  {
    type: types.STEPPER_DETAIL,
  },
  {
    type: types.STEPPER_DETAIL_DSFR,
  },
  {
    label: "Onglets",
    type: types.TABS_COMPONENT,
    editionModal: true,
    iconDSFR: "window-line",
    children: [
      {
        key: "dynamicTabs",
        type: types.DYNAMIC_TABS,
      },
    ],
  },
  {
    type: types.DYNAMIC_TABS,
    children: [
      {
        key: "tabs",
        type: types.DYNAMIC_TAB,
        value: "",
        children: [
          {
            key: "title",
            type: types.INPUT,
            value: "Titre de l'onglet",
          },
          {
            key: "children",
            type: types.DYNAMIC,
          },
        ],
      },
    ],
  },
  {
    type: types.DYNAMIC_TAB,
    label: "Onglet",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Titre de l'onglet",
      },
      {
        key: "children",
        type: types.DYNAMIC,
      },
    ],
  },
  {
    label: "Onglets",
    type: types.TABS,
    children: [
      {
        key: "tabs",
        type: types.TAB,
      },
    ],
  },
  {
    label: "Onglets",
    type: types.TABS_CARDS,
    children: [
      {
        key: "tabs",
        type: types.TAB_CARDS,
      },
    ],
  },
  {
    label: "Onglets",
    type: types.TABS_TILE_CARDS,
    children: [
      {
        key: "tabs",
        type: types.TAB_TILE_CARDS,
      },
    ],
  },
  {
    type: types.TAB,
    label: "Onglet",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Titre de l'onglet",
      },
      {
        key: "children",
        type: types.DYNAMIC,
      },
    ],
  },
  {
    type: types.DSFR_TILE_CARDS_LIST,
  },
  {
    type: types.TAB_CARDS,
    label: "Onglet",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Titre de l'onglet",
      },
      {
        key: "children",
        type: types.CARDS_LIST,
      },
    ],
  },
  {
    type: types.TAB_TILE_CARDS,
    label: "Onglet",
    children: [
      {
        key: "title",
        type: types.INPUT,
        value: "Titre de l'onglet",
      },
      {
        key: "children",
        type: types.DSFR_TILE_CARDS_LIST,
        children: [
          {
            key: "specific",
            value: "true",
          },
        ],
      },
    ],
  },
  {
    type: types.URL,
    label: "Url",
  },
  {
    type: types.VIDEO,
    editionModal: true,
    iconDSFR: "play-circle-line",
    label: "Vidéo",
    children: [
      {
        key: "source",
        type: types.SELECT,
        value: videosOrigins.VIMEO,
        label: "Source",
        options: [
          { label: "Dailymotion", value: videosOrigins.DAILYMOTION },
          { label: "Vimeo", value: videosOrigins.VIMEO },
          { label: "Youtube", value: videosOrigins.YOUTUBE },
        ],
      },
      {
        type: types.URL,
        key: "src",
        value: "",
      },
      {
        key: "title",
        label: "Titre de la vidéo (modal + accessibilité)",
        type: types.INPUT,
        value: "",
      },
      {
        key: "legend",
        label: "Légende de la vidéo",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        key: "openButtonLabel",
        label: "Label du bouton (pour afficher la transcription)",
        type: types.EDITABLE_INPUT,
        value: "Transcription",
      },
      {
        key: "closeButtonLabel",
        label: "Label du bouton (pour masquer la transcription)",
        type: types.EDITABLE_INPUT,
        value: "Transcription",
      },
      {
        key: "transcription",
        type: types.TEXT,
        value: "",
      },
    ],
  },
  {
    type: types.TABLE,
    label: "Tableau",
    iconDSFR: "table-line",
    editionModal: true,
    children: [
      {
        label: "Titre du tableau",
        key: "title",
        type: types.EDITABLE_INPUT,
        value: "",
      },
      {
        label: "Activer le multiligne",
        key: "multiline",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        key: "isActiveHeader",
        label: "Afficher le header",
        type: types.CHECKBOX,
        value: "true",
      },
      {
        label: "Desactiver le scroll horizontal",
        key: "noScroll",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        label: "Ajouter un séparateur de colonne",
        key: "bordered",
        type: types.CHECKBOX,
        value: "false",
      },
      {
        label: "Espacement des colonnes",
        key: "colSize",
        type: types.SELECT,
        options: [
          { label: "Petit", value: "sm" },
          { label: "Moyen", value: "md" },
          { label: "Grand", value: "lg" },
        ],
        value: "md",
      },
      {
        key: "header",
        type: types.TABLE_HEADER,
        children: [
          {
            key: "rows",
            type: types.TABLE_ROW,
          },
        ],
      },
      {
        key: "body",
        type: types.TABLE_BODY,
        children: [
          {
            key: "rows",
            type: types.TABLE_ROW,
          },
        ],
      },
    ],
  },
  {
    type: types.TABLE_ROW,
    label: "Ligne de tableau",
    children: [
      {
        key: "cells",
        type: types.TABLE_CELL,
      },
    ],
  },
  {
    type: types.TABLE_CELL,
    label: "Cellule de tableau",
    children: [
      {
        key: "content",
        label: "Contenu",
        type: types.TABLE_CELL_TEXT,
        value: "",
      },
    ],
  },
];

// Get a random number for ids
export const generateContentId = (content, updatedIds = {}) => {
  const newId = uuidv4();
  if (content.id && typeof updatedIds === "object") {
    // eslint-disable-next-line no-param-reassign
    updatedIds[content.id] = newId;
  }
  const contentWithId = { ...content, id: newId };
  if (content && content.children) {
    contentWithId.children = content.children.map((child) => generateContentId(child, updatedIds));
  }
  return contentWithId;
};

export const enhanceContent = (content = {}) => {
  const { type, children = [] } = content;
  const defaultContent = contents.find((c) => c.type === type);

  const enhancedContent = {
    ...defaultContent,
    ...content,
  };

  // enchanced children
  const enhancedChildren = children.map((child) => {
    const defaultChild = ((defaultContent && defaultContent.children) || []).find((c) => c.key === child.key) || {};
    return enhanceContent({
      ...defaultChild,
      ...child,
    });
  });

  // add defaults children not founds
  ((defaultContent && defaultContent.children) || []).forEach((defaultChild, index) => {
    const defaultChildAlreadyExists = enhancedChildren.find((c) => c.key === defaultChild.key);
    if ((defaultChild.value !== undefined || defaultChild.children) && !defaultChildAlreadyExists) {
      enhancedChildren.splice(index, 0, generateContentId(enhanceContent(defaultChild)));
    }
  });
  enhancedContent.children = enhancedChildren;
  return {
    ...enhancedContent,
    value: enhancedContent.value || "",
  };
};

export const deepMergeContents = (contentsA, contentsB) => {
  let finalContents = [];
  if (Array.isArray(contentsA) && Array.isArray(contentsB)) {
    finalContents = lodash.cloneDeep(contentsB);
    for (const contentA of contentsA) {
      const contentB = finalContents?.filter((c) => c.key === contentA.key);

      if (contentB.length === 0) {
        finalContents.push(contentA);
      }

      if (contentA.children && contentA.children.length) {
        contentB[0].children = deepMergeContents(contentA.children, contentB[0]?.children);
      }
    }
  }
  return finalContents;
};

export const hasDeepDiffContentsByKey = (contentsA, contentsB) => {
  if (Array.isArray(contentsA) && Array.isArray(contentsB)) {
    for (const contentA of contentsA) {
      const contentB = contentsB.filter((c) => c.key === contentA.key);
      if (contentB.length === 0) {
        return true;
      }

      if (contentA.children && contentA.children.length && contentB[0].children && contentB[0].children.length) {
        if (hasDeepDiffContentsByKey(contentA.children, contentB[0].children)) {
          return true;
        }
      }
    }
  }

  return false;
};

export const replaceContentValue = (content = {}, newChildren = [], child = {}) => {
  const { children = [], type = "" } = content;
  let newChildrenUpdate = [...newChildren];
  if (type === types.BUTTON) {
    let newSecondaryColor = children.find((c) => c.key === "secondaryColor");
    if (children.some((c) => c.key === "primary") && child.key !== "secondaryColor") {
      const isPrimary = children.find((c) => c.key === "primary")?.value === "true";
      newSecondaryColor = { ...newSecondaryColor, value: isPrimary ? "false" : "true" };
    }
    let newKind = children.find((c) => c.key === "kind");
    if (children.some((c) => c.key === "outlined") && child.key !== "kind") {
      const isOutlined = children.find((c) => c.key === "outlined")?.value === "true";
      newKind = { ...newKind, value: isOutlined ? "secondary" : "primary" };
    }
    if (newSecondaryColor) {
      newChildrenUpdate = newChildrenUpdate.filter((c) => c.key !== "secondaryColor");
      newChildrenUpdate.push(newSecondaryColor);
    }
    if (newKind) {
      newChildrenUpdate = newChildrenUpdate.filter((c) => c.key !== "kind");
      newChildrenUpdate.splice(2, 0, newKind);
    }
  }
  return newChildrenUpdate;
};

export const replacePagesByIds = (content, updatedIds = {}) => {
  const { type, value, children } = content;
  const newContent = { ...content };

  if ([types.PAGE, types.SUBPAGE, types.DSFR_SUBPAGE].includes(type) && typeof value === "object") {
    newContent.value = value.page ? value.page.id : value.pageId || "";
  } else if (type === types.CONTENTS_GROUP) {
    newContent.children = children.map((child) => {
      if (child.key === "contents") {
        return {
          ...child,
          value: updatedIds[child.value] || child.value,
          children: [],
        };
      }
      return child;
    });
  } else if (children && children.length) {
    newContent.children = children.map((child) => replacePagesByIds(child, updatedIds));
  }
  return newContent;
};

export const getDefaultContentByType = (type) => enhanceContent(contents.find((content) => content.type === type));

export const getAllDefaultContents = () => contents.map(enhanceContent);

export const adminProperties = ["label", "options", "editionModal", "icon", "iconDSFR", "min", "max", "step", "width"];

export default {};
